import { Reveal } from "./Reveal";

export default function SectionHeading({ number, kicker, title, dark = false }) {
  return (
    <Reveal>
      <div className="flex items-center gap-4 mb-6" data-testid={`section-${number}`}>
        <span className="font-heading text-sm tracking-[0.3em] text-rouge font-semibold">{number}</span>
        <span className="h-px w-12 bg-rouge" />
        <span className={`text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-white/60" : "text-steel"}`}>
          {kicker}
        </span>
      </div>
      <h2
        className={`font-heading uppercase font-semibold tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  );
}
